import { useContext } from 'react';
import {
    EapSettingsFormValidationContext,
    EapSettingsFormValidationContextType,
} from 'modules/settings/pods/settings-devices/settings-devices-eap-settings/settings-devices-eap-settings-form/contexts/eap-settings-validation-form.context';

export const useEapSettingsFormValidationContext = (): EapSettingsFormValidationContextType => {
    const context = useContext(EapSettingsFormValidationContext);
    if (context === undefined) {
        throw new Error('useEapSettingsFormValidationContext must be used within EapSettingsFormValidationProvider');
    }
    return context;
};
